
import { defineComponent, ref, watch, onMounted, getCurrentInstance, nextTick } from 'vue'
import { mapState, useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'

import BaseComponent from '@/components/Base.vue'
import DialogComponent from '@/components/Dialog.vue'
import Pop from '@/components/Pop.vue'
import VideoPlayer from '@/components/VideoPlayer.vue'
import PictureViewer from '@/components/PictureViewer.vue'

import Moment from 'moment'
import COVERAPP from '@/utils/COVERAPP'

export default defineComponent({
    name: 'App',
    components: {
        BaseComponent,
        DialogComponent,
        Pop,
        VideoPlayer,
        PictureViewer
    },
    computed: {
        ...mapState(['activityData', 'dialogData', 'popData', 'videoData', 'picViewerData'])
    },
    setup (props, context) {
        const $store = useStore()
        const router = useRouter()
        const _this = getCurrentInstance() as any
        const isApp = ref<boolean>(false)

        const getActDetail = () => {
            _this.proxy.$request('/activity/config', {
                aid: $store.state.aid
            }).then((data: any) => {
                // 设置分享信息
                data.share && setShareData(data)
                loadImgs(data)
            })
        }

        const activityStatus = (data: any) => {
            if (isApp.value && COVERAPP.Attribute.appVersion() < 700) {
                $store.commit('SET_DIALOGDATA', {
                    type: 'fail',
                    text: '亲，封面app需升级至最新版本，才能参与活动哦！',
                    btns: [
                        {
                            className: 'update-btn',
                            text: '立即升级'
                        }
                    ]
                })
            } else if (new Date(data.serverTime).getTime() < new Date(data.startTime).getTime()) {
                $store.commit('SET_DIALOGDATA', {
                    text: `亲，活动于${Moment(data.startTime).format('YYYY.MM.DD')}-${Moment(data.endTime).format('YYYY.MM.DD')}正式启动哦！`
                })
            } else if (new Date(data.serverTime).getTime() > new Date(data.endTime).getTime()) {
                $store.commit('SET_DIALOGDATA', {
                    text: '该活动已经结束'
                })
            } else if (!isApp.value && data.isAppShow) {
                $store.commit('SET_DIALOGDATA', {
                    text: '参加该活动需在封面新闻APP中进行',
                    btns: [
                        {
                            text: '确定',
                            className : 'download-btn'
                        }
                    ]
                })
            }
        }

        const setShareData = (data: any) => {
            $store.commit('SET_SHAREDATA', {
                title: data.share.title,
                desc: data.share.desc,
                imgUrl: data.share.imgUrl || 'https://wapcdn.thecover.cn/cdn/wap/img/fengmian_logo.png',
                link: window.location.href
            })
        }

        const loadImgs = (data: any) => {
            const imgs = ["animal.png","autumn.png","autumn_bg_v1.jpg","autumn_btn_01.png","autumn_btn_02.png","autumn_btn_03.png","autumn_text_v1.png","autumn_leafing_01.png","autumn_leafing_02.png","autumn_leafing_03.png","autumn_leafing_04.png","autumn_mask_bg_01.png","autumn_panda_01.png","autumn_panda_02.png","autumn_panda_03.png","autumn_panda_04.png","autumn_panda_05.png","back_btn.png","cattle_01.png","cattle_02.png","cattle_03.png","cattle_04.png","cave_v1.png","crowd.png","lama.png","logo.png","music_btn.png","panda.png","panda_01.png","panda_02.png","panda_03.png","paper_01.png","paper_02.png","paper_03.png","paper_04.png","paper_05.png","pop_arrow_next.png","pop_arrow_prev.png","pop_atlas_bg.png","pop_bg.png","pop_close.png","pop_video_btn.png","review_autumn_btn.png","review_btn_v1.png","review_spring_btn.png","review_summer_btn.png","review_winter_btn.png","share_selected.png","share_close_btn.png","share_app_text.png","share_pc_text.png","share_wap_text.png","share_autumn_bg_v1.jpg","share_summer_bg_v1.jpg","share_spring_bg_v1.jpg","share_winter_bg_v1.jpg","share_autumn_btn.png","share_spring_btn.png","share_summer_btn.png","share_winter_btn.png","share_btn.png","snowflake1.png","snowflake2.png","snowflake3.png","snowflake4.png","snowflake5.png","spring.png","spring_bg.jpg","spring_btn_01.png","spring_btn_02.png","spring_btn_03_v1.png","spring_text_v1.png","spring_greet.png","spring_last_btn.png","spring_leafing_01.png","spring_leafing_02.png","spring_leafing_03.png","spring_leafing_04.png","spring_marry.png","spring_mask_bg_01.png","spring_panda_01.png","spring_panda_02.png","spring_panda_03.png","spring_panda_04.png","spring_panda_05.png","spring_panda_06.png","spring_panda_07.png","spring_panda_08.png","step.png","summer.png","summer_bg.jpg","summer_btn_01.png","summer_btn_02.png","summer_btn_03.png","summer_text_v1.png","summer_last_btn.png","summer_leafing_01.png","summer_leafing_02.png","summer_leafing_03.png","summer_leafing_04.png","summer_mask_bg_01.png","tower.png","vulture.png","winter.png","winter_ani.png","winter_bg.jpg","winter_btn_01_v2.png","winter_btn_02.png","winter_btn_03.png","winter_btn_04_v1.png","winter_btn_05.png","winter_text_v1.png","winter_last_btn.png","winter_mask_bg_01.png","winter_title.png"]
            let index = 0
            let len = imgs.length
            for(let img of imgs) {
                _this.proxy.$common.onloadImg(`https://yunyingcdn.thecover.cn/2021qiaoqisiji/img/${img}`).then(() => {
                    index++
                    if (index == len) {
                        if (isApp.value) {
                            _this.proxy.$common.getUser((res: any) => {
                                res && $store.commit('SET_USERINFO', res)
                            })
                        }
                        $store.commit('SET_ACTIVITYDATA', data)
                        // 判断活动状态
                        activityStatus(data)
                    }
                })
            }
        }

        const horScreen = () => {
            nextTick(() => {
                const winW = window.innerWidth
                const winH = window.innerHeight
                let w = 0, h = 0
                const page = document.querySelector('.page-wrapper') as any
                if (winW < winH) {
                    w = winH
                    h = winW
                    page.style = `-webkit-transform: rotate(90deg) translate(${(winH - winW) / 2}px, ${(winH - winW) / 2}px); transform: rotate(90deg) translate(${(winH - winW) / 2}px, ${(winH - winW) / 2}px); width: ${winH}px; height: ${winW}px;`
                } else {
                    w = winW
                    h = winH
                    page.style = `width: ${winW}px; height: ${winH}px;`
                }
                _this.proxy.$common.rootRem('isHor')
            })
        }

        getActDetail()

        watch(() => router.currentRoute.value, (to, from) => {
            if (to.fullPath != from.fullPath) {
                $store.commit('SET_DIALOGDATA', null)
                _this.proxy.$common.pageLoading()
                document.documentElement.scrollTop = 0
            }
        })

        const setData = () => {
            horScreen()
            window.addEventListener('orientationchange', horScreen, false)
            window.addEventListener('resize', horScreen, false)
        }

        onMounted(() => {
            isApp.value = COVERAPP.Attribute.isApp()
            if(isApp.value) {
                document.documentElement.className = 'webview-app'
                let timeCount = 0
                const timeId = setInterval(() => {
                    setData()
                    if (timeCount >= 50 || document.documentElement.clientHeight != window.innerHeight) {
                        clearInterval(timeId)
                        return
                    }
                    timeCount++
                }, 100)
            } else {
                setData()
            }
            window.addEventListener('pageshow', (e) => {
                if (e.persisted) {
                    window.location.reload()
                }
            })   
        })

        return {

        }
    }
})

